import { useLangStore } from '../stores/lang'
import commonEn from '../locales/en'
import commonZh from '../locales/zh'

export type Messages = {
  zh: Record<string, string>
  en: Record<string, string>
}

export type TFunc = (key: string, params?: Record<string, string | number>) => string

/**
 * 模块级 i18n composable。
 *
 * 用法：
 *   import zh from './locales/zh'
 *   import en from './locales/en'
 *   const { t } = useI18n({ zh, en })
 *
 * 未传入 messages 时仅使用 base 公共词条（common.* / nav.*）。
 * 传入时按「viewEn -> viewZh -> commonEn -> commonZh」顺序回退；缺词直接返回 key。
 *
 * t() 在模板 / computed 中调用时会读取 langStore.lang，
 * 语言切换后相关模板与菜单会自动重新渲染。
 */
export function useI18n(messages?: Partial<Messages>) {
  const langStore = useLangStore()

  const t: TFunc = (key, params) => {
    const locale = langStore.lang
    const view = messages?.[locale]
    const viewZh = messages?.zh
    let str =
      view?.[key] ??
      viewZh?.[key] ??
      (locale === 'en' ? commonEn[key] : commonZh[key]) ??
      commonZh[key] ??
      key
    if (params) {
      for (const name of Object.keys(params)) {
        str = str.replace(new RegExp(`\\{${name}\\}`, 'g'), String(params[name]))
      }
    }
    return str
  }

  return { t, lang: langStore.lang }
}
